<template>
  <div>
    <v-dialog
      v-model="showDonateDialog"
      fullscreen
      max-width="640"
      style="overflow: auto; -webkit-overflow-scrolling: touch"
    >
      <v-card>
        <v-app-bar flat color="rgba(0, 0, 0, 0)">
          <v-btn @click="closeDialog" icon
            ><v-icon color="black">mdi-close</v-icon></v-btn
          >
        </v-app-bar>
        <CartComponent></CartComponent>
        <div class="pa-2">
          <v-checkbox
            v-if="cart.lineItems.length > 0"
            v-model="hasDedication"
            label="هل تريد اهداء هذا التبرع؟"
          ></v-checkbox>
          <div class="pa-2" v-if="hasDedication">
            <v-text-field
              v-model="from"
              label="من"
              required
              hint="اسم المُهدي"
            ></v-text-field>
            <v-text-field
              v-model="to"
              label="إلى"
              required
              hint="اسم المُهدى إليه"
            ></v-text-field>

            <v-alert v-if="showValidationError" dense outlined type="error">
              {{ validationErrorMessage }}
            </v-alert>
            <DedicationDesignsComponent
              @dedicationDesignSelected="designSelected"
            ></DedicationDesignsComponent>
          </div>
        </div>
        <v-card-text v-if="!isRegistered && !isAnonymousDonor">
          <v-tabs background-color="#743063" fixed-tabs dark>
            <v-tab>فاعل خير</v-tab>
            <v-tab>سجل الدخول</v-tab>
            <v-tab>متبرع جديد</v-tab>
            <v-tab-item>
              <v-card class="ma-1">
                <v-card-text>
                  <p>
                    لا مانع لدي عند اختيار "فاعل خير" بعدم استقبال رسالة نصية
                    بالتبرع أو بريد إلكتروني
                  </p>
                  <v-text-field
                    v-model="name"
                    label="الاسم (اختياري)"
                    outlined
                  ></v-text-field>
                  <v-text-field
                    v-model="email"
                    label="البريد الالكتروني (اختياري)"
                    outlined
                  ></v-text-field>
                  <v-text-field
                    v-model="phone"
                    label="رقم الهاتف (مطلوب)"
                    outlined
                  ></v-text-field>

                  <v-alert
                    v-if="showValidationErrorDonate"
                    dense
                    outlined
                    type="error"
                  >
                    {{ validationErrorMessageDonate }}
                  </v-alert>
                </v-card-text>
                <v-card-actions class="justify-center">
                  <v-btn @click="donateNow" block dark color="teal lighten-1">
                    تبرع الآن
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
            <v-tab-item><LogInComponent></LogInComponent> </v-tab-item>
            <v-tab-item> <SignUpComponent></SignUpComponent> </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-card-actions v-else justify-center>
          <v-btn
            v-if="cart.lineItems.length > 0"
            :loading="isCreatingOrder"
            @click="placeOrder"
            color="success"
            block
            >اتمام عملية التبرع</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LogInComponent from "@/components/LogInComponent";
import SignUpComponent from "@/components/SignUpComponent";
import CartComponent from "@/components/CartComponent";
import DedicationDesignsComponent from "@/components/DedicationDesignsComponent";

function isEmpty(str) {
  return !str || str.length === 0;
}

export default {
  name: "DonateComponent",

  //********************** */
  components: {
    LogInComponent,
    SignUpComponent,
    CartComponent,
    DedicationDesignsComponent,
  },

  //********************** */
  data: () => ({
    isAnonymousDonor: false,
    isCreatingOrder: false,
    name: "",
    email: "",
    phone: "",
    hasDedication: false,
    from: "",
    to: "",
    selectedDesign: null,
    showValidationError: false,
    showValidationErrorDonate: false,
    validationErrorMessage: "",
    validationErrorMessageDonate: "",
  }),

  //********************** */
  computed: {
    ...mapGetters({
      cart: "Cart/cart",
      showDonateDialog: "Cart/showDonateDialog",
      isLoggedIn: "Account/isLoggedIn",
      isRegistered: "Account/isRegistered",
      externalPaymentUrl: "Order/externalPaymentUrl",
    }),
  },

  //********************** */
  watch: {
    showDonateDialog: function (val) {
      if (val) {
        this.isAnonymousDonor = false;
      }
    },
  },

  //********************** */
  methods: {
    closeDialog: function () {
      this.$store.dispatch("Cart/dismissDonate");
    },

    designSelected: function (selectedDesign) {
      this.selectedDesign = selectedDesign;
      console.log(selectedDesign);
    },
    donateNow: function () {
      
      //updateCustomerInfo
      if (isEmpty(this.phone)) {
        this.validationErrorMessageDonate = "يجب ادخال رقم الهاتف";
        this.showValidationErrorDonate = true;
        let self = this;
        setTimeout(() => {
          self.showValidationErrorDonate = false
        }, 5000);
        return;
      }

      this.isAnonymousDonor = true;
      
      this.$store.dispatch("Account/updateCustomerInfo", {
        name: this.name,
        phone: this.phone,
      });
    },

    placeOrder: async function () {
      if (this.hasDedication) {
        await this.createOrderWithDedication();
      } else {
        await this.createOrder();
      }
    },
    createOrder: async function () {
      this.isCreatingOrder = true;
      try {
        await this.$store.dispatch("Order/createOrder");
        this.isCreatingOrder = false;
        //console.log(this.externalPaymentUrl);
        window.location = this.externalPaymentUrl.url;
      } catch (error) {
        this.showError = true;
        console.log(error)
        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }
      this.isCreatingOrder = false;
    },

    createOrderWithDedication: async function () {
      if (this.hasDedication) {
        if (isEmpty(this.from)) {
          this.validationErrorMessage = "يرجى كتابة اسم المُهدي";
          this.showValidationError = true;
          return;
        }

        if (isEmpty(this.to)) {
          this.validationErrorMessage = "يرجى كتابة اسم المُهدى إليه";
          this.showValidationError = true;
          return;
        }
      }

      let model = {
        from: this.from,
        to: this.to,
        dedicationDesignId: this.selectedDesign.id,
      };

      this.isCreatingOrder = true;

      try {
        await this.$store.dispatch("Order/createOrderWithDedication", model);
        this.isCreatingOrder = false;
        //console.log(this.externalPaymentUrl);
        window.location = this.externalPaymentUrl.url;
      } catch (error) {
        this.showError = true;

        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }
      this.isCreatingOrder = false;
    },
  },

  //*********************** */
  async mounted() {},
};
</script>

<style>
</style>